import api from 'api';

interface AzureSubscriptionSchema {
  subscriptionName: string;
  primaryKey: string;
  secondaryKey: string;
}

export interface AzureApplicationSchema {
  acessTokenURL: string;
  applicationId: string;
  clientSecret: string;
  objectId: string;
  scope: string;
  subscriptions: AzureSubscriptionSchema[];
}

export const fetchAzureApplications = async (businessId: number) => {
  const response: AzureApplicationSchema | null = await api.get(
    `AzureApplication/GetAzureApplicationByBusinessId/${businessId}`,
  );
  return response;
};

export const resetAzureApplication = async (businessId: number) => {
  const response: AzureApplicationSchema = await api.put(
    `AzureApplication/ResetAzureApplicationClientSecret/${businessId}`,
  );
  return response;
};

export const createAzureApplication = async (payload: FormData) => {
  const response: AzureApplicationSchema = await api.post(
    'AzureApplication/CreateAzureApplication',
    payload,
  );
  return response;
};
